import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import AchievementRing from "./AchievementRing";
import ActualValuesDonut from "./ActualValuesDonut";
import EndDateChangeRing from "./EndDateChangeRing";
import ElapsedTimeCircle from "./ElapsedTimeCircle";
import ValueChangeCircle from "./ValueChangeCircle";
import ApexLineAchievement from "./ApexLineAchievement";
import WeatherRadarChart from "./WeatherRadarChart";
import BasisTableComponent from "../table/BasisTableComponent";
import Saudi_Riyal_Symbol from "../../../images/Saudi_Riyal_Symbol-1.png";

const ProjectDetails = () => {
  const { id } = useParams();

  const [projectDetailes, setProjectDetailes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [extractsTotal, setExtractsTotal] = useState({});
  const [projectAmount, setProjectAmount] = useState({});
  const [achievementPercentage, setAchievementPercentage] = useState({});
  const [actualWorkData, setActualWorkData] = useState(null);
  const [endDateChangeRate, setEndDateChangeRate] = useState(null);
  const [elapsedPercentage, setElapsedPercentage] = useState(null);
  const [valueChangePercentage, setValueChangePercentage] = useState(null);
  const [monthlyAchievement, setMonthlyAchievement] = useState([]);
  const [weatherInfo, setWeatherInfo] = useState({});
  const [weatherStats, setWeatherStats] = useState({
    clear: 0,
    rainy: 0,
    cloudy: 0,
    winds: 0,
  });
  
  const [approvedRequests, setApprovedRequests] = useState([]);
  const [approvedPagination, setApprovedPagination] = useState({
    page: 1,
    pages: 1,
  });
  const [underEvaluationRequests, setUnderEvaluationRequests] = useState([]);
  const [underEvaluationPagination, setUnderEvaluationPagination] = useState({
    page: 1,
    pages: 1,
  });
  


  const fetchProjectDetails = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/project_card?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.ok) {
        throw new Error("فشل في جلب بيانات المشروع");
      }

      const result = await res.json();
      setProjectDetailes(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchextractsTotal = async () => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/approved_extracts_total?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setExtractsTotal(data);
    } catch (err) {
      console.error("خطأ:", err);
      setExtractsTotal({});
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectAmount = async () => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/amount?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setProjectAmount(data);
    } catch (err) {
      console.error("خطأ:", err);
      setProjectAmount({});
    } finally {
      setLoading(false);
    }
  };

  const fetchAchievementPercentage = async () => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/achievement_percentage?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
      const data = await res.json();
      setAchievementPercentage(data);
    } catch (err) {
      console.error("خطأ:", err);
      setAchievementPercentage({});
    } finally {
      setLoading(false);
    }
  };

  const fetchActualWorkData = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/actual_work_values?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل جلب البيانات");
      const data = await res.json();
      setActualWorkData(data);
    } catch (err) {
      console.error("خطأ:", err);
      setActualWorkData(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchEndDateChangeRate = async () => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/end_date_change_rate?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل جلب نسبة التغير في نهاية المشروع");
      const data = await res.json();
      setEndDateChangeRate(data?.percentage_time_change);
    } catch (err) {
      console.error("خطأ:", err);
      setEndDateChangeRate(null);
    }
  };

  const fetchElapsedTime = async () => {
    try {
      const res = await fetch(
        "https://promaster.areez.co/api/projects/average_actual_price",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في جلب نسبة المدة المنقضية");
      const data = await res.json();
      setElapsedPercentage(data.elapsed_period_percentage);
    } catch (err) {
      console.error(err);
      setElapsedPercentage(null);
    }
  };

  const fetchValueChange = async () => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/value_change_rate?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل جلب معدل التغير في القيمة");
      const data = await res.json();
      setValueChangePercentage(data.percentage_change);
    } catch (err) {
      console.error(err);
      setValueChangePercentage(null);
    }
  };

  const fetchMonthlyAchievement = async () => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/monthly_achievement_trend?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل في جلب بيانات الإنجاز الشهري");
      const data = await res.json();
      setMonthlyAchievement(data.monthly_achievement);
    } catch (err) {
      console.error(err);
    }
  };
  
  const fetchApprovedRequests = async (page = 1) => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/approved_requests?project_id=${id}&page=${page}&per_page=10`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (!res.ok) throw new Error("فشل في جلب الطلبات المعتمدة");
  
      const data = await res.json();
  
      setApprovedRequests(data.approved_requests || []);
      setApprovedPagination({
        page: data.page,
        pages: Math.ceil(data.total_results / data.per_page),
      });
    } catch (error) {
      console.error("خطأ:", error);
      setApprovedRequests([]);
      setApprovedPagination({ page: 1, pages: 1 });
    }
  };

  const fetchUnderEvaluationRequests = async (page = 1) => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/under_evaluation_requests?project_id=${id}&page=${page}&per_page=10`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (!res.ok) throw new Error("فشل في جلب الطلبات تحت التقييم");
  
      const data = await res.json();
  
      setUnderEvaluationRequests(data.under_evaluation_requests || []);
      setUnderEvaluationPagination({
        page: data.page,
        pages: Math.ceil(data.total_results / data.per_page),
      });
    } catch (error) {
      console.error("خطأ:", error);
      setUnderEvaluationRequests([]);
      setUnderEvaluationPagination({ page: 1, pages: 1 });
    }
  };

  const fetchWeatherStats = async () => {
    try {
      const res = await fetch(
        `https://promaster.areez.co/api/projects/weather_stats?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) throw new Error("فشل تحميل إحصائيات الطقس");
  
      const data = await res.json();
      if (data.weather_stats && typeof data.average_temperature !== "undefined") {
        setWeatherStats(data.weather_stats)
        setWeatherInfo(data);
      } else {
        setWeatherInfo({});
      }
    } catch (err) {
      console.error("خطأ في جلب بيانات الطقس:", err);
      setWeatherInfo({});
    }
  };
  

  useEffect(() => {
    fetchProjectDetails();
    fetchextractsTotal();
    fetchProjectAmount();
    fetchAchievementPercentage();
    fetchActualWorkData();
    fetchEndDateChangeRate();
    fetchElapsedTime();
    fetchValueChange();
    fetchMonthlyAchievement();
    fetchWeatherStats();
    fetchApprovedRequests();
    fetchUnderEvaluationRequests();
  }, [id]);

  const contractMonths = (projectDetailes.contract_period / 30).toFixed(1);

  const approvedRequestsColumns = [
    { label: "نوع الطلب", field: "type" },
    { label: "رقم الطلب", field: "name" },
    {
      label: "تاريخ التقديم",
      field: "request_date",
      render: (row) =>
        new Date(row.request_date).toLocaleDateString("ar-EG"),
    },
  ];

  const underEvaluationColumns = [
    { label: "نوع الطلب", field: "type" },
    { label: "رقم الطلب", field: "name" },
    {
      label: "تاريخ التقديم",
      field: "request_date",
      render: (row) =>
        new Date(row.request_date).toLocaleDateString("ar-EG"),
    },
    {
      label: "نسبة التقدم",
      field: "progress_percentage",
      render: (row) => `${row.progress_percentage}%`,
    },
  ];
  
  

  if (loading) return <p className="text-center mt-3">جاري التحميل...</p>;
  if (!actualWorkData)
    return <p className="text-center mt-3 text-danger">لا توجد بيانات.</p>;

  return (
    <>
      <h4
        style={{
          fontFamily: "Cairo",
          marginBottom: "30px",
          color: "#2C3E50",
          textAlign: "center",
          fontWeight: "700",
        }}
      >
        {projectDetailes.project_name}
      </h4>
      <div className="row" style={{ fontFamily: "Cairo" }}>
        <div className="col-lg-4 col-md-12 mb-4">
          <div className="card" style={{ background: "#0f3a3ded" }}>
            <div className="card-body p-4 text-white text-center">
              <table
                className="table table-bordered text-center"
                style={{ borderColor: "#0f3a3ded" }}
              >
                <tbody>
                  {[
                    { label: "المالك", value: projectDetailes.owner?.name },
                    {
                      label: "الاستشاري",
                      value: projectDetailes.consultant?.name,
                    },
                    {
                      label: "المقاول",
                      value: projectDetailes.contractor?.name,
                    },
                    {
                      label: "تاريخ بداية المشروع",
                      value: new Date(
                        projectDetailes.date_start
                      ).toLocaleDateString("ar-EG"),
                    },
                    {
                      label: "مدة العقد",
                      value: `${contractMonths} أشهر (${projectDetailes.contract_period} يوم)`,
                    },
                  ].map(({ label, value }, idx) => (
                    <tr key={idx}>
                      <th
                        style={{
                          backgroundColor: "#0f3a3ded",
                          color: "white",
                          fontWeight: "600",
                        }}
                      >
                        {label}
                      </th>
                      <td
                        style={{
                          backgroundColor: "#0f3a3ded",
                          color: "white",
                          fontWeight: "600",
                        }}
                      >
                        {value || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-lg-8 col-md-12">
          <div className="row">
            <div className="col-md-4 mb-4">
              <div
                className="widget-stat card "
                style={{ backgroundColor: "#d0ecf7", border: "none" }}
              >
                <div className="card-body p-4 d-flex flex-column justify-content-center align-items-center text-white text-center">
                  <p
                    className="mb-2"
                    style={{ color: "#0c5460", fontWeight: "600" }}
                  >
                    قيمة المستخلصات المعتمدة
                  </p>
                  <h2
                    style={{
                      fontSize: "30px",
                      fontWeight: "bold",
                      color: "#0c5460",
                      paddingTop: "5px",
                    }}
                  >
                    {Number(
                      extractsTotal.approved_total_amount
                    ).toLocaleString()}
                    <img
                      src={Saudi_Riyal_Symbol}
                      width={30}
                      style={{ marginTop: "-14px", marginRight: "5px" }}
                      alt="ر.س"
                    />
                  </h2>
                  <p
                    className="mb-1"
                    style={{ color: "#0c5460", fontWeight: "600" }}
                  >
                    عدد المستخلصات:{" "}
                    <strong>{extractsTotal.approved_payment_count}</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <div
                className="widget-stat card "
                style={{ backgroundColor: "#d4edda", border: "none" }}
              >
                <div className="card-body p-4 d-flex flex-column justify-content-center align-items-center text-white text-center">
                  <p
                    className="mb-2"
                    style={{ color: "#6c757d", fontWeight: "600" }}
                  >
                    قيمة المشروع
                  </p>
                  <h2
                    style={{
                      fontSize: "26px",
                      fontWeight: "bold",
                      color: "#6c757d",
                      paddingTop: "5px",
                    }}
                  >
                    {Number(projectAmount.project_amount || 0).toLocaleString()}
                    <img
                      src={Saudi_Riyal_Symbol}
                      width={30}
                      style={{ marginTop: "-14px", marginRight: "5px" }}
                      alt="ر.س"
                    />
                  </h2>
                  <p
                    className="mb-1"
                    style={{ color: "#6c757d", fontWeight: "600" }}
                  >
                    قيمة العقد:{" "}
                    <strong>
                      {Number(
                        projectAmount.contract_amount || 0
                      ).toLocaleString()}{" "}
                    </strong>
                    و معدل التغير:{" "}
                    <strong>
                      {projectAmount.percentage_change != null
                        ? `${projectAmount.percentage_change}%`
                        : "-"}
                    </strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <div
                className="card"
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                <AchievementRing
                  percentage={achievementPercentage.achievement_percentage || 0}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="row">
      <div className="col-md-4 mb-4">
              {actualWorkData && <ActualValuesDonut data={actualWorkData} />}
            </div>
            {valueChangePercentage !== null && (
              <div className="col-md-2" style={{paddingTop:"150px"}}>
                <ValueChangeCircle percentage={valueChangePercentage} />
              </div>
            )}

            {endDateChangeRate !== null && (
              <div className="col-md-2" style={{paddingTop:"150px"}}>
                <EndDateChangeRing percentage={endDateChangeRate} />
              </div>
            )}

            {elapsedPercentage !== null && (
              <div className="col-md-2" style={{paddingTop:"150px"}}>
                <ElapsedTimeCircle percentage={elapsedPercentage} />
              </div>
            )}
      </div>
      <div className="row">

    
      <div className="col-md-6 mb-4">
    <ApexLineAchievement data={monthlyAchievement} />
  </div>

  
  {/* {weatherInfo?.stats ? (

) : (
  <div className="col-md-6 mb-4">
    <p className="text-center text-muted">لا توجد بيانات طقس متاحة حالياً.</p>
  </div>
)} */}

<div className="col-md-6 mb-4">
     <WeatherRadarChart
  weatherStats={weatherStats | {}}
  avgTemp={weatherInfo.average_temperature | 0}
/>
  </div>




<div className="col-12 col-lg-6  mb-4">
<BasisTableComponent
  title="الطلبات المعتمدة"
  data={approvedRequests}
  columns={approvedRequestsColumns}
  pagination={approvedPagination}
  onPageChange={(newPage) => fetchApprovedRequests(newPage)}
/>
</div>

<div className="col-12 col-lg-6 mb-4">
  <BasisTableComponent
    title="الطلبات تحت التقييم"
    data={underEvaluationRequests}
    columns={underEvaluationColumns}
    pagination={underEvaluationPagination}
    onPageChange={(newPage) => fetchUnderEvaluationRequests(newPage)}
  />
</div>



      </div>
    </>
  );
};

export default ProjectDetails;
